export const signupReqData = {
  "firstName": "",
  "lastName": "",
  "email": "",
  "phone": "",
  "userType": "", //Customer, Agent, Affiliate, Business
  "password": ""
}